import { render, staticRenderFns } from "./ActiveSchools.vue?vue&type=template&id=879cf7e4&"
import script from "./ActiveSchools.vue?vue&type=script&lang=js&"
export * from "./ActiveSchools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports